import * as React from "react"
import PropTypes from "prop-types"
import Breadcrumb from "./breadcrumb"

const Header = ({ day, pageTitle }) => (
  <header className="bg-orange-50">
    <div
      className="left-4 p-4 text-cdfblue font-mono
      border-b border-cdfblue"
    >
      <Breadcrumb day={"Day " + day} title={pageTitle} />
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
